export const Polish = [
  ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
  ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
  ['Z', 'X', 'C', 'V', 'B', 'N', 'M'],
  ['ą'.toUpperCase(), 'ć'.toUpperCase(), 'ę'.toUpperCase(), 'ł'.toUpperCase(), 'ń'.toUpperCase(), 'ó'.toUpperCase(), 'ś'.toUpperCase(), 'ź'.toUpperCase(), 'ż'.toUpperCase()]
]
